module.exports = __webpack_public_path__ + "img/00591531000368.0c8f65e3.png";